import React from 'react';
import Link from 'react-router/lib/Link';
import PropTypes from 'prop-types';

import * as styles from './ArticlesRead.scss';
import images from '../../../static/images/RealtorLanding';
import appendLocale from '../../helpers/appendLocale';
import { language, QUERY_PARAMS } from '../../constants';

const ArticlesRead = (props) => {
    const recommendedArticles = [
        {
            images: images.connectionBetweenPublicTransport,
            link: '/articles/HJSb_6ILY',
            text: 'connectionBetweenPublicTransport'
        },
        {
            images: images.speciallyRealEstateAgents,
            link: '/articles/SJZYOpLIY',
            text: 'speciallyRealEstateAgents'
        },
        {
            images: images.sellAHouse,
            link: '/articles/rkRJ4P55u',
            text: 'sellAHouse'
        },
        {
            images: images.reliableBroker,
            link: '/articles/Hy_QV3j5O',
            text: 'reliableBroker'
        }
    ];

  const buildArticleUrl = (link) =>
    props.locale === language.default
      ? link
      : `${appendLocale(props.locale, link)}?${QUERY_PARAMS.SKIP_TRANSLATION}=true`;

    const renderCards = () =>
        recommendedArticles.map((item) => (
            <Link key={item.text} to={buildArticleUrl(item.link)}>
                <div className={styles.cards}>
                    <img src={item.images} alt="" />
                    <p>{props.translate('RecommendedRrticles', item.text)}</p>
                </div>
            </Link>
        ));

    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>
                {props.translate('RecommendedRrticles', 'title')}
            </p>
            <div className={styles.cardsWrapper}>
                {renderCards()}
            </div>
        </div>
    );
};

ArticlesRead.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string
};

export default ArticlesRead;
